import { getLayout, layoutClass, slotClass, blockClass, type InspectionLayoutId } from '@jobos/shared';

import { cn } from '@/lib/utils';
import { useInspectionLayoutCss } from './PageCanvas';

// A miniature schematic of a layout, rendered from the same registry + layout
// CSS the real page uses (so the preview matches what you'll get). Photo slots
// show as gray boxes, text regions as a few lines.
export function LayoutThumbnail({ id }: { id: InspectionLayoutId }) {
  useInspectionLayoutCss();
  const layout = getLayout(id);
  return (
    <div className={cn('ins-thumb', layoutClass(id))}>
      {layout.slots.map((s) => (
        <div key={s.key} className={cn('ins-slot', slotClass(s.key))} />
      ))}
      {layout.blocks.map((b) => (
        <div key={b.key} className={cn('ins-block', blockClass(b.key), 'ins-thumb-block')}>
          <span />
          <span />
          <span />
        </div>
      ))}
    </div>
  );
}
